// extracted by mini-css-extract-plugin
export default {"button":"copyBtn_button__Qeekn"};